import Config from '../config';
import { Divider, Modal } from 'antd';
import { WarningTwoTone,CheckCircleTwoTone } from '@ant-design/icons';

let logging = Config.logging;


export const logMessage  = (message) => {
  if (logging == true) {
    console.log(message);
  }
  return;
};



export const showMessageModal = (message) => {
  let modal;

  modal = Modal.confirm({
    title: '',
    closable: true,//display icon
    cancelText: "Close",
    content: (
      <>
        <div className="row ">
            <div className="col-xxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                <div className="d-flex gap-2">
                    <WarningTwoTone
                        twoToneColor="#ed0d0d"
                        style={{
                            fontSize: '16px',
                            paddingTop: '3px'
                        }}
                    />

                    <div style={{paddingRight:"1rem",textAlign:"left"}}>
                        {' '}

                        {
                            message
                        }
                        
                    </div>
                </div>
            </div>
        </div>
        <Divider />
      </>
    ),
    onOk() {},
    okButtonProps: {
      style: { display: 'none' },
    },
    // cancelButtonProps: {
    //   style: { display: 'none' },
    // },
    className: 'custom-error-modal text-center',
  });
};

export const showSuccessMessageModal = (message) => {
  let modal;

  modal = Modal.confirm({
    title: '',
    maskClosable: true, 
    closable: true,//display icon
    content: (
      // <div>
      //   <div className="pt-2" style={{
      //     fontSize: "1rem",
      //     fontWeight: "bold",
      //     color:"#1c5c93"
      //   }}>{message}</div>
      //   <div className="pt-4">
      //     <button
      //       className="btn-primary-custom btn-md"
      //       onClick={() => {
      //         modal.destroy(); // Close the modal
      //       }}
      //     >
      //       Close
      //     </button>
      //   </div>
      // </div>
      <>
        <div className="row ">
            <div className="col-xxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                <div className="d-flex gap-2">
                    <CheckCircleTwoTone
                        twoToneColor="#52c41a"
                        style={{
                            fontSize: '16px',
                            paddingTop: '3px'
                        }}
                    />

                    <div style={{paddingRight:"1rem",textAlign:"left"}}>
                        {' '}

                        {
                            message
                        }
                        
                    </div>
                </div>
            </div>
        </div>
        <Divider />
      </>
    ),
    cancelText: "Close",
    onOk() {},
    okButtonProps: {
       style: { display: 'none' },
    },
    // cancelButtonProps: {
    //   style: { display: 'none' },
    // },
    className: 'custom-error-modal text-center',
  });
};
